export default {
  assetScope: {
    title: 'Asset Usage Rules',
    ruleTab: 'Usage Rules',
    defaultTab: 'Default Policy',
    recycleTab: 'Recycle Bin',
    addRule: 'Add Store Asset Usage Rule',
    ruleName: 'Rule Name',
    shopName: 'Store Name',
    groupName: 'Store Group Name',
    targetName: 'Applicable Stores',
    matchType: 'Usage Method',
    matchShop: 'Asset Origin Store Only',
    matchGroup: 'Specified Store Group',
    useType: 'Usage Method',
    isUsed: 'Usage Status',
    used: 'Used',
    unused: 'Unused',
    createTime: 'Created At',
    deleteTime: 'Deleted At',
    action: 'Actions',
    view: 'View',
    edit: 'Edit',
    delete: 'Delete',
    restore: 'Restore',
    permanentDelete: 'Delete Permanently',
    addTitle: 'Add Asset Usage Rule',
    basicInfo: 'Basic Information',
    usageSection: 'Usage Method',
    usageHelpTitle: 'How Asset Rules Take Effect',
    usageHelpDescription: 'When members use assets, the current usage rules list is queried in real time, without distinguishing existing and new assets by their creation time.',
    usageHelpOrderTitle: 'Real-Time Evaluation Order',
    usageHelpOrderDescription: 'If a manual rule matches, the scope is restricted according to its usage method. Otherwise, the current configuration on the Default Policy tab applies. Rules in the recycle bin are excluded from queries.',
    editTitle: 'Edit Asset Usage Rule',
    viewTitle: 'View Asset Usage Rule',
    deleteTitle: 'Delete Asset Usage Rule',
    deleteRuleTitle: 'Delete {ruleName}',
    deleteConfirmTitle: 'Confirm Rule Deletion',
    deleteRuleLabel: 'Rule: {ruleName}',
    deleteMoveNotice: 'After deletion, this rule moves from the usage rules list to the recycle bin.',
    deleteRecycleInactive: 'Rules in the recycle bin are excluded from real-time usage checks',
    deleteImpactNotice: 'This change affects the available scope of existing and new assets from the relevant stores. Please confirm before continuing.',
    deleteUsageNotice: 'When members use assets, only the usage rules list is checked. If no manual rule matches, the current configuration on the Default Policy tab applies.',
    deleteRestorable: 'Can be restored from the recycle bin',
    deleteConfirmAction: 'Confirm Deletion',
    confirmDelete: 'Move this asset usage rule to the recycle bin?',
    confirmRestore: 'Restore this asset usage rule?',
    restoreRuleTitle: 'Restore {ruleName}',
    restoreConfirmTitle: 'Confirm Rule Restoration',
    restoreUsageNotice: 'After restoration, this rule returns to the usage rules list and is included in real-time queries when members use assets.',
    restoreAvailabilityNotice: 'This rule can be restored if its scope is not occupied by a usage rule.',
    restoreRecycleNotice: 'The record will no longer remain in the recycle bin after restoration',
    restoreConfirmAction: 'Confirm Restoration',
    ruleNamePlaceholder: 'Enter a rule name',
    targetPlaceholder: 'Select a scope',
    shopScopeHint: 'Member assets created at this store can only be used at this store: {name}',
    groupScopeHint: 'Member assets created within this store group can only be used within this group: {name}',
    selectShopFirst: 'Please select a store first',
    selectGroupFirst: 'Please select a store group first',
    overridesDefaultPolicy: 'Overrides default policy',
    remark: 'Remark',
    remarkPlaceholder: 'Enter a remark',
    save: 'Save',
    confirm: 'Confirm',
    select: 'Select',
    selectShop: 'Select Store',
    applicableShops: 'Applicable Stores',
    shopSelectionTip: 'The store list is fixed when saved. Newly added stores are not included automatically.',
    selectedShopCount: '{count} stores selected',
    sourceShopOnly: 'Only usable at asset-origin store',
    sourceShopOnlyTip: 'When enabled, assets can only be used at the store where they were created. When disabled, selected stores can share assets.',
    enabled: 'On',
    disabled: 'Off',
    effectNoticeTitle: 'Effect',
    effectNoticeDescription: 'The rule immediately affects existing and new assets created at the selected stores. Stores without a rule follow the default policy.',
    shopRequired: 'Select at least one applicable store',
    shopCountLabel: '{count} stores selected',
    selectedShopsShare: 'Selected stores can share',
    selectShopGroup: 'Select Store Group',
    searchName: 'Search by name or city',
    selected: 'Selected',
    shopCode: 'Store Code',
    shopStatus: 'Store Status',
    shopEnabled: 'Enabled',
    shopDisabled: 'Disabled',
    shopPending: 'Pending opening',
    shopPlanned: 'Planned opening',
    shopOperating: 'Operating',
    shopSuspended: 'Temporarily closed',
    shopClosed: 'Permanently closed',
    region: 'Region',
    city: 'City',
    ruleOccupancy: 'Rule Occupancy',
    usageAvailable: 'Available for rule',
    usageOccupied: 'Already has a rule',
    usageSelected: 'Selected by current rule',
    shopCount: 'Store Count',
    coveredShopCount: 'Covered Stores',
    shopUnit: 'stores',
    occupied: 'Occupied by another rule',
    defaultTitle: 'Default policy for unconfigured stores',
    ruleDefaultPolicyHint: 'When members use assets, the usage rules list is queried in real time. If a manual rule matches, that rule applies; otherwise, the current configuration on the Default Policy tab applies.',
    defaultDescription: 'Applies only when the asset’s source store does not match a manual usage rule; switching immediately affects existing and new assets from the relevant stores.',
    policyRule: 'Unconfigured store pool only',
    policyRuleDesc: 'Stores without manual rules form a dynamic pool. Member assets created in these stores can only be shared within the pool.',
    policyRuleScenario: 'Suitable for default sharing without affecting stores that already have manual rules.',
    policyTenant: 'All stores',
    policyTenantDesc: 'Member assets created in stores without manual rules can be used in all stores.',
    policyTenantScenario: 'Suitable for centralized headquarters control where member assets are shared across all stores by default.',
    policySource: 'Source store only',
    policySourceDesc: 'Member assets created in stores without manual rules can only be used in the store where they were created.',
    policySourceScenario: 'Suitable for strict isolation by default, with each store initially accepting only its own assets.',
    policyMostPermissive: 'Most permissive',
    policyMostRestrictive: 'Most restrictive',
    policyRecommended: 'Recommended',
    policyCurrent: 'Currently in use',
    saveDefault: 'Save and Apply',
    switchDefaultTitle: 'Switch Default Policy',
    switchDefaultConfirmTitle: 'Confirm Default Policy Switch',
    currentDefaultPolicy: 'Current default usage',
    nextDefaultPolicy: 'Default usage after switch',
    switchEffective: 'Effect of this change',
    switchEffectiveNow: 'Effective immediately',
    manualRulePriority: 'Manual rules take priority; recycled rules are not considered.',
    manualRulePriorityDesc: 'Only affects assets that do not match a manual rule',
    switchDefaultNotice: 'This change affects the available scope of existing and new assets from stores without manually configured rules. Please confirm before continuing.',
    confirmSwitch: 'Confirm Switch',
    loadFailed: 'Failed to load',
    selectRequired: 'Select a scope',
    nameRequired: 'Enter a rule name',
    removeSuccess: 'Moved to recycle bin',
    restoreSuccess: 'Restored successfully',
    saveSuccess: 'Saved successfully',
    switchSuccess: 'Default policy switched',
    noPermanentDelete: 'The permanent delete API is not available',
    shop: 'Store',
    group: 'Store Group',
  },
};
